// The app's own line icons (ui/glyphs.ts) as inline SVG — the dashboard's only icon
// source (ui/DESIGN.md §2). Decorative: always aria-hidden, so the control that
// carries a glyph owns the accessible name. Sized like the icon library it replaced
// (24px box), so a size-* class or the button recipe's [&_svg]:size-[1.125em]
// decides the drawn size.

import type { SVGProps } from "react";
import { GLYPHS, type GlyphName } from "@ahcut/ui/glyphs";
import { cn } from "@/lib/cn";

export type { GlyphName };

export interface GlyphProps extends Omit<SVGProps<SVGSVGElement>, "name" | "children"> {
  name: GlyphName;
  size?: number;
}

export function Glyph({ name, size = 24, className, ...rest }: GlyphProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      focusable="false"
      {...rest}
      aria-hidden="true"
      className={cn("shrink-0", className)}
    >
      {GLYPHS[name].map(([tag, attrs], i) =>
        tag === "circle" ? <circle key={i} {...attrs} /> : tag === "rect" ? <rect key={i} {...attrs} /> : <path key={i} {...attrs} />,
      )}
    </svg>
  );
}
